module.exports = __webpack_public_path__ + "static/media/netflix.cf20a9f9.svg";